import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from './common/Navbar/Navbar';
import Home from './components/Home/index';
import Mission from './components/Mission/Mission';
import Gallery from './components/Gallery/Gallery';
import Footer from './common/Footer/Footer';
import About from './components/About/About';
import ContactPage from './components/Contact/Contact';
import Donate from './common/Donation/Donate';
import DonationForm from './common/DonationForm/DonationForm';
import PrivacyPolicy from './policies/privacy-policy';
import ContactUs from './policies/contact-us/contact-us';
import TermsOfUse from './policies/term-of-use.js/term-of-use';
import OurMission from './policies/mission/mission';
import SuccessStories from './policies/success/success';
import TermsService from './policies/term-service/term-service';
import AboutUs from './policies/about-us/about';
import Membership from './policies/membership/membership';
import ScrollToTop from './scrolltotop';
import Receipt from './common/Receipt/receipt';
function App() {
  return (
    <>
      <Router>
        <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/mission" element={<Mission/>} />
        <Route path="/gallery" element={<Gallery/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/donate" element={<Donate/>} />
        <Route path="/contact" element={<ContactPage/>} />
        <Route path="/donate-form" element={<DonationForm/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/contact-us" element={<ContactUs/>} />
        <Route path="/terms-of-use" element={<TermsOfUse/>} />
        <Route path="/our-mission" element={<OurMission/>} />
        <Route path="/success" element={<SuccessStories/>} />
        <Route path="/terms-service" element={<TermsService/>} />
        <Route path="/about-us" element={<AboutUs/>} />
        <Route path="/membership" element={<Membership/>} />
        <Route path="/receipt/:paymentId" element={<Receipt/>} />
      </Routes>
      <Footer/>
    </Router>
    </>
  );
}

export default App;
